module.exports = __webpack_public_path__ + "assets/img/ducks-1.4728221d.jpeg";